import React from 'react';
import HomeCategory from '../component/HomeCategory';
import Eventexpo from '../component/EventExpo';
import FreshArrivals from '../component/FreshArrivals';
import OfferBanner from '../component/OfferBanner';
import Herobanner from '../component/Herobanner';
import { motion } from 'framer-motion';
//import InstallAppButton from '../component/InstallAppButton';

const Homepage = () => {
return (
     <motion.div
        initial={{ opacity:0 }}
        animate={{ opacity:1 }}
        transition={{ duration:0.5 }}
       >
      <Herobanner />
      {/* <InstallAppButton /> */}
      <HomeCategory />
      {/* <ComingSoon /> */}
      <Eventexpo />
      <FreshArrivals />
      <OfferBanner />
      {/* <MyCollections /> */}
    </motion.div>
  );
};
export default Homepage;